import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect:'/Homeindex',
    children:[
      // 首页
          {
             path:'/Homeindex',
             name:'Homeindex',
             component: () => import('@/components/Homeindex.vue')
          },
      // 缅怀堂
          {
            path:'/Hemorialhall',
            name:'Hemorialhall',
            component: () => import('@/components/Hemorialhall.vue'),
            meta: {
              keepAlive: true //此页面需要缓存
            }
         },
      // 感人故事
         {
            path:'/Touchingstory',
            name:'Touchingstory',
            component: () => import('@/components/Touchingstory.vue')
         },
      // 缅怀活动 
         {
            path:'/Memorialactivities',
            name:'Memorialactivities',
            component: () => import('@/components/Memorialactivities.vue')
         },
      // 感谢信
         {
            path:'/Thankyouletter',
            name:'Thankyouletter',
            component: () => import('@/components/Thankyouletter.vue')
         },
      // 政策法规
        {
          path:'/Policiesregulations',
          name:'Policiesregulations',
          component: () => import('@/components/Policiesregulations.vue'),
          // meta: {
          //   keepAlive: true //此页面需要缓存
          // }  
        },
      // 联系我们 
        {
          path:'/Contactus',
          name:'Contactus',
          component: () => import('@/components/Contactus.vue')
        },
      // 缅怀堂详情
        {
         path:'/Hemorialhallinfor',
         name:'Hemorialhallinfor',
         component: () => import('@/components/Hemorialhallinfor/Hemorialhallinfor.vue')
        },
        // 感谢信详情
        {
        path:'/thankletterinfor',
        name:'thankletterinfor',
        component: () => import('@/components/thankletterinfor/thankletterinfor.vue')
       },
        // 感谢信详情
        {
          path:'/thankletterinforone',
          name:'thankletterinforone',
          component: () => import('@/components/thankletterinfor/thankletterinforone.vue')
         },
        // 感人故事详情
        {
          path:'/storyDetails',
          name:'storyDetails',
          component: () => import('@/components/details/details.vue')
         },
          // 活动预告详情
        {
          path:'/activeDetails',
          name:'activeDetails',
          component: () => import('@/components/details/detailImg.vue')
        },
        // 政策法规更多
        {
          path:'/moreindex',
          name:'moreindex',
          component: () => import('@/components/more/morenindex.vue')
        },
      ]
  },

]

const router = new VueRouter({
  routes,
  scrollBehavior (to  , from ,savedPosition) {
    // console.log(to);
    // console.log(from);
    // console.log(savedPosition);
    if(to.name=='noticeBidding' || to.name=='noticeInfo' || to.name=='noticeHit'){
      if (to.hash) {
      return {
        selector: to.hash
      }
    }
    }else{
      return { x: 0, y: 0 }
    }
    
    
  }
})

export default router
